import React from 'react';
import { TaskDependencyGridSkeleton } from '../../common/ContentSkeletons';

export default function EventTaskDependencyPanel({ view }) {
  const {
    TASK_PRIORITY_LABELS,
    TASK_STATUS_LABELS,
    calcDueDays,
    eventTaskAddingDependency,
    eventTaskAddingDependencyTaskId,
    eventTaskCanEdit,
    eventTaskDependencies,
    eventTaskDependenciesLoading,
    eventTaskDependencyBlockRef,
    eventTaskDependencyCandidateTasks,
    eventTaskDependencyLinkType,
    eventTaskDependencyPickerFocused,
    eventTaskDependencyQuery,
    eventTaskRemovingDependencyTaskId,
    eventTaskSectionNameMap,
    formatDate,
    formatDueHint,
    handleAddEventTaskDependency,
    handleRemoveEventTaskDependency,
    handleRemoveEventTaskSuccessor,
    jstTodayYmd,
    normalizeEventTaskStatus,
    normalizeTaskPriority,
    openEventTaskDetailModal,
    setEventTaskDependencyLinkType,
    setEventTaskDependencyPickerFocused,
    setEventTaskDependencyQuery,
  } = view;

  return (
    <>
                        <div
                          ref={eventTaskDependencyBlockRef}
                          className="event-task-detail-modal__dependencyBlock"
                        >
                          <h4>
                            依存関係
                            <small>
                              先行 {eventTaskDependencies.predecessors.length} / 後続{' '}
                              {eventTaskDependencies.successors.length}
                            </small>
                          </h4>
                          {eventTaskDependenciesLoading ? (
                            <TaskDependencyGridSkeleton classPrefix="event-task-detail-modal" />
                          ) : (
                            <>
                              {eventTaskCanEdit ? (
                                <div className="event-task-detail-modal__dependencyComposer">
                                  <div className="event-task-detail-modal__dependencyTypeTabs">
                                    <button
                                      type="button"
                                      className={
                                        eventTaskDependencyLinkType === 'predecessor' ? 'is-active' : ''
                                      }
                                      onClick={() => setEventTaskDependencyLinkType('predecessor')}
                                      disabled={eventTaskAddingDependency}
                                    >
                                      先行タスクを追加
                                    </button>
                                    <button
                                      type="button"
                                      className={
                                        eventTaskDependencyLinkType === 'successor' ? 'is-active' : ''
                                      }
                                      onClick={() => setEventTaskDependencyLinkType('successor')}
                                      disabled={eventTaskAddingDependency}
                                    >
                                      後続タスクを追加
                                    </button>
                                  </div>
                                  <div className="event-task-detail-modal__dependencySearchWrap">
                                    <i className="fa-solid fa-magnifying-glass" />
                                    <input
                                      value={eventTaskDependencyQuery}
                                      onChange={(e) => setEventTaskDependencyQuery(e.target.value)}
                                      onFocus={() => setEventTaskDependencyPickerFocused(true)}
                                      onBlur={() => {
                                        window.setTimeout(() => setEventTaskDependencyPickerFocused(false), 120);
                                      }}
                                      placeholder="タスクを見つける"
                                      disabled={!eventTaskCanEdit || eventTaskAddingDependency}
                                    />
                                  </div>
                                  {(eventTaskDependencyPickerFocused || eventTaskDependencyQuery.trim()) &&
                                  eventTaskCanEdit ? (
                                    <div className="event-task-detail-modal__dependencyCandidates">
                                      {eventTaskDependencyCandidateTasks.length === 0 ? (
                                        <p className="event-task-detail-modal__emptyText">候補がありません。</p>
                                      ) : (
                                        <ul>
                                          {eventTaskDependencyCandidateTasks.map((candidate) => (
                                            <li key={candidate.id}>
                                              <button
                                                type="button"
                                                className="event-task-detail-modal__dependencyCandidateBtn"
                                                onMouseDown={(e) => e.preventDefault()}
                                                onClick={() => {
                                                  void handleAddEventTaskDependency(candidate.id);
                                                }}
                                                disabled={
                                                  eventTaskAddingDependency &&
                                                  eventTaskAddingDependencyTaskId === String(candidate.id)
                                                }
                                              >
                                                <span className="event-task-detail-modal__dependencyCandidateTitle">
                                                  <span className="event-task-detail-modal__priorityInlineText">
                                                    {TASK_PRIORITY_LABELS[
                                                      normalizeTaskPriority(candidate.priority)
                                                    ]}
                                                  </span>
                                                  <span>{candidate.title || '名称未設定'}</span>
                                                </span>
                                                <span className="event-task-detail-modal__dependencyCandidateMeta">
                                                  <span>
                                                    {eventTaskSectionNameMap.get(
                                                      String(candidate.sectionId || '')
                                                    ) || '未分類'}{' '}
                                                    /{' '}
                                                    {TASK_STATUS_LABELS[
                                                      normalizeEventTaskStatus(candidate.status)
                                                    ] || '未着手'}
                                                  </span>
                                                  {candidate.dueOn ? (
                                                    <span>
                                                      {formatDate(candidate.dueOn)} (
                                                      {formatDueHint(calcDueDays(candidate.dueOn, jstTodayYmd))}
                                                      )
                                                    </span>
                                                  ) : (
                                                    <span>期限未設定</span>
                                                  )}
                                                </span>
                                              </button>
                                            </li>
                                          ))}
                                        </ul>
                                      )}
                                    </div>
                                  ) : null}
                                </div>
                              ) : null}
                              <div className="event-task-detail-modal__dependencyGrid">
                                <section>
                                  <h5>先行タスク</h5>
                                  {eventTaskDependencies.predecessors.length === 0 ? (
                                    <p className="event-task-detail-modal__emptyText">未設定</p>
                                  ) : (
                                    <ul className="event-task-detail-modal__dependencyList">
                                      {eventTaskDependencies.predecessors.map((dependencyTask) => (
                                        <li key={dependencyTask.id}>
                                          <button
                                            type="button"
                                            className="event-task-detail-modal__dependencyJump"
                                            onClick={() => openEventTaskDetailModal(dependencyTask)}
                                          >
                                            <span className="event-task-detail-modal__dependencyJumpTitle">
                                              <span className="event-task-detail-modal__priorityInlineText">
                                                {TASK_PRIORITY_LABELS[
                                                  normalizeTaskPriority(dependencyTask.priority)
                                                ]}
                                              </span>
                                              <span>{dependencyTask.title || '名称未設定'}</span>
                                            </span>
                                            <small>
                                              {TASK_STATUS_LABELS[
                                                normalizeEventTaskStatus(dependencyTask.status)
                                              ] || '未着手'}
                                            </small>
                                          </button>
                                          {eventTaskCanEdit ? (
                                            <button
                                              type="button"
                                              className="event-task-detail-modal__dependencyRemove"
                                              onClick={() => {
                                                void handleRemoveEventTaskDependency(dependencyTask.id);
                                              }}
                                              disabled={
                                                eventTaskRemovingDependencyTaskId ===
                                                String(dependencyTask.id)
                                              }
                                            >
                                              {eventTaskRemovingDependencyTaskId ===
                                              String(dependencyTask.id)
                                                ? '削除中...'
                                                : '解除'}
                                            </button>
                                          ) : null}
                                        </li>
                                      ))}
                                    </ul>
                                  )}
                                </section>
                                <section>
                                  <h5>後続タスク</h5>
                                  {eventTaskDependencies.successors.length === 0 ? (
                                    <p className="event-task-detail-modal__emptyText">未設定</p>
                                  ) : (
                                    <ul className="event-task-detail-modal__dependencyList">
                                      {eventTaskDependencies.successors.map((dependencyTask) => (
                                        <li key={dependencyTask.id}>
                                          <button
                                            type="button"
                                            className="event-task-detail-modal__dependencyJump"
                                            onClick={() => openEventTaskDetailModal(dependencyTask)}
                                          >
                                            <span className="event-task-detail-modal__dependencyJumpTitle">
                                              <span className="event-task-detail-modal__priorityInlineText">
                                                {TASK_PRIORITY_LABELS[
                                                  normalizeTaskPriority(dependencyTask.priority)
                                                ]}
                                              </span>
                                              <span>{dependencyTask.title || '名称未設定'}</span>
                                            </span>
                                            <small>
                                              {TASK_STATUS_LABELS[
                                                normalizeEventTaskStatus(dependencyTask.status)
                                              ] || '未着手'}
                                            </small>
                                          </button>
                                          {eventTaskCanEdit ? (
                                            <button
                                              type="button"
                                              className="event-task-detail-modal__dependencyRemove"
                                              onClick={() => {
                                                void handleRemoveEventTaskSuccessor(dependencyTask.id);
                                              }}
                                              disabled={
                                                eventTaskRemovingDependencyTaskId ===
                                                `succ:${dependencyTask.id}`
                                              }
                                            >
                                              {eventTaskRemovingDependencyTaskId ===
                                              `succ:${dependencyTask.id}`
                                                ? '削除中...'
                                                : '解除'}
                                            </button>
                                          ) : null}
                                        </li>
                                      ))}
                                    </ul>
                                  )}
                                </section>
                              </div>
                            </>
                          )}
                        </div>
    </>
  );
}
